<!--
Author: erba-28
Create Time: 2019-06-21 14:31:39
Description:
-->
<template>
  <div class="com--data-importer">

    <div
      class="com--data-importer-wrapper"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-upload
        ref="uploader"
        class="com--data-importer-upload"
        :action="uploadUrl"
        multiple
        data-ignore-limit="1"
        data-ignore-on-exceed="handleExceed"
        :file-list="fileList"
        :show-file-list="showFileList"
        :accept="importExcelAcceptTypes"
        :before-upload="beforeImportExcel"
        :on-success="handleSuccess"
        :on-error="handleError"
        :auto-upload="false"
        :on-change="handleFileListChange"
        :on-remove="handleFileListRemove"
        list-type="none"
        :headers="headers"
        v-show="!isLoading"
      >
        <el-button slot="trigger" size="small" type="primary">添加文件</el-button>
        <el-button size="small" type="primary" @click="submitUpload">上传</el-button>
        <!-- <el-button type="primary" icon="el-icon-plus">导入</el-button> -->

        <!-- <div slot="tip" class="el-upload__tip">只能上传excel文件</div> -->
        <el-dropdown @command="downloadTemplate" v-if="templates.length > 0">
          <el-button  size="small" type="primary">
            模板下载<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
             <el-dropdown-item v-for="item in templates" :key="item.code" :command="item.code">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-upload>
    </div>
    <DataImportPreviewer ref="data-import-previewer" :preUploadUrl="preUploadUrl" @DataImportHandleConfirm="dataImportHandleConfirm" />
  </div>
</template>

<script>
import DataImportPreviewer from './DataImportPreviewer.vue'

export default {
  name: 'DataImporter',
  components: {
    DataImportPreviewer
  },
  props: {
    templates: {
      type: Array,
      default: () => [], // [{ code: 'businessTemplateCode', name: '业务模板名称'  }]
    },
    uploadUrl: {
      type: String,
    },
    preUploadUrl: {
      type: String,
    },
    showFileList: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      fileList: [],
      // uploadUrl: `${baseURL}/data-import/import-excel`,
      // preUploadUrl: `${baseURL}/data-import/pre-import-excel`,
      isLoading: false,
      graphImgUploadHeaders: { Authorization: '' }
    }
  },
  computed: {
    importExcelAcceptTypes () {
      return this.importExcelAcceptExts
        .replace(/;/g, ',')
        .replace(/\*[.]/g, '.')
    },
    importExcelAcceptExts () {
      return '*.xls;*.xlsx'
    },
    headers(){
            return{
                "Authorization":sessionStorage.getItem("Token")
            }
        }
  },
  activated() {
                  this.graphImgUploadHeaders.Authorization = sessionStorage.getItem('Token');
                },
  methods: {
    dataImportHandleConfirm(val) {
      if(val === "success"){
        this.$emit("DataImportConfirm","success");
      }
    },
    downloadTemplate (command) {
      const vm = this
      const template = vm.templates.find(o => o.code === command);
      if (template['url']) {
        window.location.href = template['url'] + '?code=' + command
      }
      vm.$emit('download-template', template, vm.templates);
    },
    // 上传前
    beforeImportExcel (file) {
      const vm = this
      const exts = vm.importExcelAcceptExts.split(';')
      if (
        !exts.some(
          t =>
            t.substring(t.indexOf('.')) ===
            file.name.substring(file.name.lastIndexOf('.'))
        )
      ) {
        vm.$message({
          type: 'info',
          message: '导入Excel (' + file.name + ') 格式不允许，请重新选择'
        })
        return false
      }
      return true
    },
    submitUpload () {
      const vm = this

      if (vm.fileList.length === 0) {
        vm.$message({
          type: 'warning',
          message: '请选择待上传文件'
        })
        return
      }

      // preview
      vm.$refs['data-import-previewer']
        .preview(vm.fileList)
        .then(() => {
          vm.isLoading = true
          vm.$refs['uploader'].submit()
        })
        .catch(reason => {
        })
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    handleSuccess (response, file, fileList) {
      const vm = this
      if (fileList.indexOf(file) > -1) {
        fileList.splice(fileList.indexOf(file), 1)
      }
      vm.isLoading = false
      if (response.code === '200') {
        if (response.message && response.message.indexOf('错误消息:') > -1) {
          vm.$message({
            type: 'warning',
            message: `${file.name} ${response.message || '导入成功'}`,
            showClose: true,
            duration: 30000
          })
        } else {
          vm.$message.success(`${file.name} ${(process.env.NODE_ENV === 'development' ? response.message : '') || '导入成功'}`)
        }
        vm.$emit("DataImportConfirm","success");
        vm.$emit("receiveSearch");
      } else {
        vm.$message({
          type: 'warning',
          message: `${file.name} ${(process.env.NODE_ENV === 'development' ? response.message : '') || '导入失败'}`,
          showClose: true,
          duration: 30000
        })
      }
    },
    handleError (err, file, fileList) {
      const vm = this
      if (fileList.indexOf(file) > -1) {
        fileList.splice(fileList.indexOf(file), 1)
      }
      vm.isLoading = false
      vm.$message({
        type: 'error',
        message: `上传文件 ${file.name} 错误` + err.message,
        showClose: true,
        duration: 30000
      })
    },
    handleFileListChange (file, fileList) {
      const vm = this

      fileList = fileList.filter(item => vm.beforeImportExcel(item))

      const fileNameList = fileList.map(item => item.name)
      vm.$set(
        vm,
        'fileList',
        fileList.filter((item, itemIndex) => {
          // 如果有同名文件，取最后添加的
          return itemIndex === fileNameList.lastIndexOf(item.name)
        })
      )
    },
    handleFileListRemove (file, fileList) {
      const vm = this

      fileList = fileList.filter(item => vm.beforeImportExcel(item))

      const fileNameList = fileList.map(item => item.name)
      vm.$set(
        vm,
        'fileList',
        fileList.filter((item, itemIndex) => {
          // 如果有同名文件，取最后添加的
          return itemIndex === fileNameList.lastIndexOf(item.name)
        })
      )
    }
  },
}
</script>

<style scoped lang="scss">

.com--data-importer {
  height: 100%;
  display: inline-block;
}
.com--data-importer-wrapper {
  /* height: 100%; */
}

</style>

<style lang="scss">
.com--data-importer-upload .el-upload--text {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/dataImport/DataImporter.vue